import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import Loadable from 'react-loadable';


import Menu from '../components/Menu/Menu';

import * as Context from '../context';

import Loader from '../components/UI/Loader/Loader';
import PrincipalPage from '../components/PrincipalPage/PrincipalPage';
import useWindowSize from '../utils/useWindowSize';
import { QueryClient, QueryClientProvider } from 'react-query';


const LoadableRestaurant = Loadable({
  loader: () => import('../components/Restaurant/RestaurantMenu'),
  loading: Loader,
});

const LoadableMarket = Loadable({
  loader: () => import('../components/Market/Market'),
  loading: Loader,
});

const LoadableParking = Loadable({
  loader: () => import('../components/Parking/Parking'),
  loading: Loader,
});

const LoadableDiscounts = Loadable({
  loader: () => import('../components/Discounts/Discounts'),
  loading: Loader,
});

const LoadableBenefits = Loadable({
  loader: () => import('../components/Benefits/Benefits'),
  loading: Loader,
});
const LoadableBirthdays = Loadable({
  loader: () => import('../components/Birthdays/Birthdays'),
  loading: Loader,
});

const LoadableQr = Loadable({
  loader: () => import('../components/Qr/Qr'),
  loading: Loader,
})
const LoadableApril = Loadable({
  loader: () => import('../components/April/April'),
  loading: Loader,
})
const LoadableAutomanagement = Loadable({
  loader: () => import('../components/Automanagement/Automanagement'),
  loading: Loader,
})

const Login = Loadable({
  loader: () => import('../components/Login/Login.js'),
  loading: Loader,
});

const LoadableLogout = Loadable({
  loader: () => import('../components/Logout/Logout'),
  loading: Loader,
});

const LoadableTachometer = Loadable({
  loader: () => import('../components/Tachometer/Tachometer'),
  loading: Loader,
})

const ApplicationRouter = () => {
  useWindowSize();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      }
    }
  })
  
  return (
    <Router>
      <QueryClientProvider client={queryClient}> 
        <Context.Auth.Provider>
          <Context.Auth.Consumer>
            {Auth => (
              <Context.BackgroundImage.Provider>
                <Context.MattUtilities.Provider>
                  <Context.MattUtilities.Consumer>
                    {MattUtilities => (
                      <React.Fragment>
                        <Switch>
                          <Route
                            path="/login"
                            render={props => <Login Auth={Auth} {...props} />}
                          />
                          <PrivateRoute exact path="/" component={PrincipalPage} Auth={Auth} MattUtilities={MattUtilities}/>
                          <PrivateRoute path="/parqueadero" component={LoadableParking} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/mercado" component={LoadableMarket} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/restaurante" component={LoadableRestaurant} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/descuentos" component={LoadableDiscounts} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/beneficios" component={LoadableBenefits} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/cumpleanos" component={LoadableBirthdays} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/qr" component={LoadableQr} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/gym" component={LoadableApril} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/automanagement" component={LoadableAutomanagement} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/tachometer" component={LoadableTachometer} Auth={Auth} MattUtilities={MattUtilities} />
                          <PrivateRoute path="/logout" component={LoadableLogout} Auth={Auth} />
                        </Switch>
                        {Auth.isLoggedIn && <Menu />}
                      </React.Fragment>
                    )}
                  </Context.MattUtilities.Consumer>
                </Context.MattUtilities.Provider>
              </Context.BackgroundImage.Provider>
            )}
          </Context.Auth.Consumer>
        </Context.Auth.Provider>
      </QueryClientProvider>
    </Router>
  )
}

function PrivateRoute({ component: Component, Auth, MattUtilities, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        Auth.isLoggedIn ? (
          <Component Auth={Auth} MattUtilities={MattUtilities} {...props} />
        ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          )
      }
    />
  )
}

export default ApplicationRouter;